import type { IconNode } from '../types';

/**
 * @name mop
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgMjJjMi43NjEgMCA1LTEuNzkgNS00LTQuNDIgMC00LjA4LTUtOC41LTVhMSAxIDAgMTAwIDl6YTMgMyAwIDAxLTMtMyIgLz4KICA8cGF0aCBkPSJNMTIuNSAxMS41IDIyIDIiIC8+CiAgPHBhdGggZD0ibTYuOTggMTMuMDIgMi42NjUtMi42NjRhMS4yMSAxLjIxIDAgMDExLjcxIDBsMi4yOSAyLjI4OGExLjIxIDEuMjEgMCAwMTAgMS43MTJsLTIuMDg4IDIuMDg3IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/mop
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const Mop: IconNode = [
  ['path', { d: 'M10 22c2.761 0 5-1.79 5-4-4.42 0-4.08-5-8.5-5a1 1 0 100 9za3 3 0 01-3-3' }],
  ['path', { d: 'M12.5 11.5 22 2' }],
  [
    'path',
    {
      d: 'm6.98 13.02 2.665-2.664a1.21 1.21 0 011.71 0l2.29 2.288a1.21 1.21 0 010 1.712l-2.088 2.087',
    },
  ],
];

export default Mop;
